import { REMOVE_TOAST_MESSAGE } from './actionTypes';

export default (message) => ({
  type: REMOVE_TOAST_MESSAGE,
  payload: {
    message
  }
});